import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

import { BRAND_STATUSES } from '../../brands/constants'
import { DEFAULT_PAGE } from '../constants'

const BrandStatusFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { brandStatus } = getQueryParams(search)

  const handleChange = useCallback(
    brandStatus =>
      history.push(
        createUrl(pathname, search, {
          brandStatus,
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Brand status">
      <Select
        style={{ width: '100%' }}
        value={brandStatus}
        onChange={handleChange}
        allowClear
      >
        {map(BRAND_STATUSES, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default BrandStatusFilter
